import styled from 'styled-components';

import { CalendarOutlined } from '@ant-design/icons';

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PopoverHeader = styled.div`
  color: #f78e1e;
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
`;

export const PopoverBody = styled.div`
  .col-right {
    text-align: right;
  }
`;

export const CalendarIcon = styled(CalendarOutlined)`
  font-size: 10px;
  color: #f78e1e;
  border: 1px solid #f78e1e;
  padding: 2px;
  cursor: pointer;
`;

export const Divider = styled.div`
  display: flex;
  clear: both;
  width: 100%;
  min-width: 100%;
  margin: 24px 0;
  padding: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
`;
